export default {"src":"/_next/static/media/ic-algorithm.863edc3a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};